import _axios from '@/assets/utils/_axios'
import connectSocket from '@/assets/utils/connectSocket'
import BaseConfig from '@/assets/config/URLConfig'
import Router from '@/router'
import { _confirm,_alert,_loading } from '../../assets/utils/utils';
import { timers } from 'jquery';
import store from '@/store/index'
// import {isInArray} from '../../assets/utils/GlobalFunction'

let isDev = process.env.NODE_ENV === 'development';
let WS_URL = isDev ? BaseConfig.DEV_WS_URL : BaseConfig.WS_URL;         //webSocket连接网址
const NUM = 10;

export default {
    /*用户-管理员申请提现*/
    async Withdrawal({ commit, state,dispatch,getters},{data,successFun}) {
      let url='';
      let loading =  _loading({target: '.user-center',text: '正在提交申请...'});
      // successFun(loading);
      // return
      switch (getters.userInfo.type) {
        case 99:
          url = '/pc/Admin/Refund';
          break;
        default:
          url = '/pc/Hotel/Refund';
          break;
      }
      let res = await _axios.post(url,{...data});
      if (res.code === '00000'){
        successFun(loading);
      }else{
        loading.close();
      };
    },
  /*用户登录*/
  async UserLogin ({ commit, getters,dispatch}, { url, data, type ,res}) {
    if(!res){
      res = await _axios.post(url, data);
    }
    if (res.code === '00000') {
      let isAdmin = type === 'admin';
      let openId = isAdmin ? '' : res.data.uid==res.data.wechat_openid*1?'':res.data.wechat_openid;       //用户的微信openId
      let status = isAdmin ? 1 : Number(res.data.status);                            //用户的注册状态0禁用1正常2注册中
      let verify = 0;                                                                //门店认证状态
      let userType = isAdmin ? 99 : res.data.type;                                   //用户类型
      let level = res.data.level;                                                    //用户级别
      let num = res.data.uid||res.data.id;                                           //用户Id
      let loginMsg = isAdmin ? {
        ...res.data,
        token: res.data.token,
        socketType: 'admin',
        type: 99
      } : res.data
      connectSocket(WS_URL, type, num);                                                //连接webSocket
      commit('UPDATELOGININFO', { ...loginMsg, socketType: type })                     //更新用户的登录信息
      if (!getters.isGroup && !isAdmin) {                                              //非集团用户且非管理员登录时初始化当前用户为当前门店
        commit('UPDATECURRENTSTORE', {
          num: res.data.num,                          //当前用户Id
          type: userType,                             //当前门店类型
          storeId:'',                                    //当前门店Id  
          verify,                                     //当前门店认证状态
          status,                                     //当前门店注册状态
          openId,                                     //当前门店的微信openId
          level,                                      //当前门店级别
        })
      }
      
      if (isAdmin) {
        Router.push('/userCenter');
        return
      }
      //未绑定微信去注册页面的绑定微信页面
      if (res.data.wechat_openid==''&&level!=2&&level!=1||res.data.wechat_openid==res.data.uid&&level!=2&&level!=1) {0.
        Router.push({name:'regWechat'});
        return
      }
      // //已绑定微信的集团用户直接去会员中心
      if (status === 1) {
        Router.push({ name: 'CenterIndex'});
        return
      }
      //供应商-销售、登录跳转主页或关联页面
      if (status == 2&&userType==3||status == 3&&userType==3) {
         Router.push({ name: 'regBasicClose'});
         return
      }
     //采购商跳转填写门店信息 
      if (status == 2&&userType==2) {
         Router.push({ name: 'resBasicInfo'});
        return
      }
    }else{
      //返回错误状态
      return res;
    }
  },
  /*查看供应商-销售是否是关联状态、如果关联跳转过渡等待页面*/
  async POST_CheckUnionApply({ commit }, data={}) {
    let res = await _axios.post('/pc/User/CheckUnionApply', data);
    console.log(res)
  },
  /*查看供应商-创建门店是否是审核状态、如果审核跳转过渡等待页面*/
  async POST_HotelInfo({ commit,getters }, {data,successFun}) {
    let res = await _axios.post('/pc/User/HotelInfo', {store_id: getters.storeInfo.storeId});
    if (res.code === '00000') {
      successFun(res.data.info)
    };
  },
  /*用户重置密码*/
  ResetPwd ({ commit }, data) {
    _confirm('确定重置密码么？', async () => {
      let loading = _loading();
      let res = await _axios.post('/pc/Reglogin/ResetPassword', data);
      loading.close();
      if (res.code === '00000') _alert('密码重置成功', () => Router.push('/'));
    })
  },
  /*用户注册第一步 - 手机号注册*/
  RegisterPhone ({ commit }, data) {
    _confirm('确定提交注册么？', async () => {
      let loading = _loading();
      let res = await _axios.post('/pc/Reglogin/reg', data);
      loading.close();
      if (res.code === '00000') {
        commit('UPDATELOGININFO', { ...res.data, socketType: 'user' })     //更新用户的登录信息
        connectSocket(WS_URL, 'user', res.data.uid);                      //连接webSocket
        Router.push('/register/wechat')                                   //去绑定微信
      }
    })
  },
  /*退出登录*/
  logout ({ commit, state }, flag = true) {
    const outFun = async () => {
      let resData = await _axios.post('/pc/Reglogin/Logout', {})
      if (resData.code === '00000' || resData.code === '60000'|| resData.code === '10009') {
        let type = state.userLoginMessage.type;
        window.localStorage.removeItem('userLoginMessage')      //删除localStorage
        window.localStorage.removeItem('refresh')
        window.webSocket.close()                                //关闭webSocket连接
        if (type === 99) window.location.href = '/adminLogin';  //跳转到登录页
        else window.location.href = '/'
      }
    }
    if (flag) _confirm('确认退出么？', outFun);                //用户手动退出弹出确认框，其他情况静默退出
    else outFun();
  },
  /*直接退出登录*/
  exit () {
    window.localStorage.removeItem('userLoginMessage')      //删除localStorage
    window.localStorage.removeItem('refresh');
      // 如果 WebSocket 存在，并且不是已关闭/正在关闭
    if (window.webSocket && window.webSocket.readyState !== 2 && window.webSocket.readyState !== 3) {
      window.webSocket.close();
      console.log("WebSocket 已主动关闭")
    }                             //关闭webSocket连接
    window.location.href = '/';  //跳转到登录页
  },
  /*
  ** 
   ********************************新版本注册接口***********************************************
  *
  **/
 
   /*酒店(供应商)企业注册*/
  regEnterprise ({ commit }, {data,successFun}) {
    _confirm('确定提交注册么？', async () => {
      let loading = _loading();
      let res = await _axios.post('/pc/Reglogin/RegEnterprise', data);
      // let res={
      //   code: "00000",
      //   data:{
      //     info:{
      //       password: "123456",
      //       username: "xNRXXAdX2s"
      //     }
      //   }
      // }
      loading.close();
      if (res.code === '00000') {
         successFun(res.data);
        // commit('UPDATELOGININFO', { ...res.data, socketType: 'user' })     //更新用户的登录信息
        // connectSocket(WS_URL, 'user', res.data.uid);                      //连接webSocket
        // Router.push('/register/wechat')                                   //去绑定微信
      }
    })
  },
  /*销售(个人)注册*/
  RegBuyEnterprise ({ commit }, {data,successFun}) {
    _confirm('确定提交注册么？', async () => {
      // let res={
      //   code:'00000',
      //   data:{
      //     info:{
      //       mobile:'18888888884',
      //       password:'123456',
      //     }
      //   }
      // };
      //18888888882采购商/18888888883供应商
      // res.info={
      //   mobile:'18888888882',
      //   password:'123456',
      // }  
      let loading = _loading();
      let url = data.type==3?'/pc/Reglogin/RegSale':'/pc/Reglogin/RegBuyPersonal';
      let res = await _axios.post(url, data);
            loading.close();
      if (res.code === '00000') {
        successFun(res.data);
      }if(res.code === '10088'){
         _alert(res.msg);
      }
    })
  },
   /*注册-个人-企业信息-保存*/
  async POST_RegBuyPersonalFill({ commit, state,dispatch},{data,successFun}) {
        let loading = _loading();
        let res = await _axios.post('/pc/User/RegBuyPersonalFill', data);
        loading.close();
        if (res.code === '00000'){_alert('信息保存成功', () => successFun())};
  },
  /*采购商-个人-企业信息-保存*/
  async POST_BuyEnterpriseSave({ commit, state,dispatch,getters},{data,successFun}) {
        let loading = _loading();
        let res = await _axios.post('/pc/User/BuyEnterpriseSave', data);
        loading.close();
        if (res.code === '00000') {
          //供应商未生成门店ID则返回保存的门店ID
          if(getters.storeInfo.storeId==''){ 
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
          userMessage.store_id_arr = [res.data.info.store_id];
          commit('UPDATELOGININFO', { ...userMessage })
            commit('UPDATECURRENTSTORE', {
              storeId: res.data.info.store_id,          //当前门店Id
            })
          }
          _alert('信息保存成功', () => successFun());
        };
  },
  /*采购商-个人-企业信息-提交审核*/
  async POST_BuyEnterpriseSubmit({ commit, state,dispatch},{data,successFun}) {
        let loading = _loading();
        let res = await _axios.post('/pc/User/BuyEnterpriseSubmit', data);
        loading.close();
        if (res.code === '00000'){_alert('提交审核成功,请耐心等待审核', () => successFun())};
  },
  /*采购商-个人-企业信息-获取*/
  async POST_TravelInfo({ commit, state,dispatch},{data,successFun}) {
        let res = await _axios.post('/pc/User/TravelInfo', data);
        if (res.code === '00000') return successFun(res.data);
        // if (res.code === '00000') _alert('信息保存成功', () => dispatch('getStoreInfo'));
  },
  /*用户注册验证酒店名称 - 是否存在*/
  async POST_checkStoreTitle ({ commit }, data) {
    let res = await _axios.post('/pc/Visitor/CheckStoreTitle',data);
    if (res.code === '00000') return res.data.list;
  },
  /*用户关联酒店申请*/
  POST_UnionApply({ commit, state,dispatch},{data,successFun}) {
    _confirm('确定提交加入申请？', async () => {
      let loading = _loading();
      let res = await _axios.post('/pc/User/UnionApply', data);
      loading.close();
      if (res.code === '00000') successFun();
    })
  },
  /*用户解除关联酒店申请*/
  POST_UnionRemoveApply({ commit, state,dispatch},{data,successFun}) {
    _confirm('确定提交解除关联申请？', async () => {
      let loading = _loading();
      let res = await _axios.post('/pc/User/UnionRemoveApply', data);
      loading.close();
      if (res.code === '00000') successFun();
    })
  },
  /*酒店通过关联申请*/
  POST_UnionPass({ commit, state,dispatch},{data,type,successFun}) {
    _confirm(type==2?'确定通过此加入申请？':'确定通过此解除申请？', async () => {
      let loading = _loading();
      let url = type==2?'/pc/Common/UnionPass':'/pc/Common/UnionRemovePass';
      let res = await _axios.post(url, data);
      loading.close();
      if (res.code === '00000') successFun();
    })
  },
  /*酒店拒绝关联申请*/
  POST_UnionReject({ commit, state,dispatch},{data,type,successFun}) {
    _confirm(type==2?'确定拒绝此加入申请？':'确定拒绝此解除申请？', async () => {
      let loading = _loading();
      let url = type==2?'/pc/Common/UnionReject':'/pc/Common/UnionRemoveReject';
      let res = await _axios.post(url, data);
      loading.close();
      if (res.code === '00000') successFun();
    })
  },
  /*酒店解除关联*/
  POST_UnionRemove({ commit, state,getters},{data,type,successFun}) {
    _confirm('确定解除此销售？', async () => {
      let res = await _axios.post('/pc/Common/UnionRemove', {store_id:getters.storeInfo.storeId,...data});
      if (res.code === '00000') successFun();
    })
  },
  /*酒店邀请人员二维码*/
  async POST_GetInviteUnionQRCode({ commit, state,dispatch},{data,type,successFun}) {
      let res = await _axios.post('/pc/WechatApplet/GetInviteUnionQRCode', data);
      if (res.code === '00000') successFun(res.data);
  },
  /*用户修改登录密码*/
  async modifyPwd({ commit, state,dispatch},{data,successFun}) {
    let loading = _loading({target: '.d-center'});
    let res = await _axios.post('/pc/User/SetPassword',data);
    loading.close();
    if (res.code === '00000') _alert('修改密码成功，下次登录请使用新密码',() =>successFun());
  },
  /*用户修改登录手机号*/
  async modifyPhone({ commit, state,dispatch },{data,successFun}) {
    let loading = _loading({target: '.d-center'});
    let res = await _axios.post('/pc/User/MobileBind',{...data});
    loading.close();
    if (res.code === '00000') _alert('修改绑定手机号成功,下次登录请使用新手机号',() =>successFun());
  },
  /*用户修改绑定邮箱*/
  async modifyEmail({ commit, state,dispatch },data) {
    let loading = _loading({target: '.d-center'});
    let res = await _axios.post('/pc/AuthAndBind/bindEmail',data);
    loading.close();
    if (res.code === '00000') _alert('修改绑定邮箱号成功',() => commit('UPDATELOGININFO',{...state.userLoginMessage,email:data.email}));
  },
  /*修改用户名*/
  async modifyTruename({ commit, state,dispatch },data) {
    let res = await _axios.post('/pc/User/SetTruename',data);
    if (res.code === '00000') _alert('用户名修改成功',() => {dispatch('updateInfo')
      
    });
  },
  /*获取用户微信绑定信息*/
  async getUserWechat({ commit, state,dispatch,getters}) {
    let res = await _axios.post('/pc/User/GetWechatUserInfo', { store_id: getters.isGroup ? getters.storeInfo.grostoreId : getters.storeInfo.storeId });
    switch (res.code) {
      case '00000':
        let avatar123 = res.info.headimgurl.split('/');
        if(res.info.headimgurl){
          let index = avatar123.length - 1;
          avatar123[index] = '0';
        }

        let avatar = avatar123.join('/');
        commit('UPDATEWECHATINFO',{
          avatar,
          nickName: res.info.nickname,
          openid: res.info.openid
        });
        break;
      case '10009':
      case '10033':
        return dispatch('getWechatQRCode');
    }
  },
  /*用户微信解绑*/
  async unBindUserWechat({ commit, state,dispatch }) {
    let res = await _axios.post('/pc/AuthAndBind/untieWechat',{});
    if (res.code === '00000') {
      commit('UPDATEWECHATINFO',{
        avatar:'',
        nickName: '',
        openid: ''
      });
      return dispatch('getWechatQRCode');
    }
  },
  /*获取微信二维码进行绑定操作*/
  async getWechatQRCode() {
    let res = await _axios.post('/pc/AuthAndBind/getWechatQrcode',{});
    if (res.code === '00000') return res.info.path;
  },
  /*用户获取会员中心的头部信息*/
  async getUserHead ({ commit, state, getters }) {
    let t = getters.storeInfo.type, url = ''; 
    switch (t) {
      case 2:
        url = '/pc/User/TravelInfo';
        break
      case 3:
        url = '/pc/Home/HotelDetail';
        break
    }
    let res = await _axios.post(url, { store_id: getters.storeInfo.storeId });
    if (res.code === '00000'){
      res = res.data|| {};
      let userStore = {
        ...res.info,
      }
      //非集团用户将门店信息也展示
      // if (userStore.level != 1) userStore.title = res.store_data.title
      // if (!res.user_data.groupname || userStore.level != 1) userStore = { ...userStore, ...res.store_data }
      // let total = 0;
      // res.user_data.unread_msg_count.forEach(v => total += v.counts);
      // let sysArr = res.user_data.unread_msg_count.filter(v => v.type == 1),
      //     tradeArr = res.user_data.unread_msg_count.filter(v => v.type == 2);
      // commit('UPDATEUNREAD', {
      //   sys:sysArr[0] ? sysArr[0].counts : 0,
      //   trade:tradeArr[0] ? tradeArr[0].counts : 0,
      // });
      //不是管理员时更新本地用户昵称新
      if(getters.userInfo.type==99) return;
      let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
      userMessage.truename? userMessage.truename = res.info.title : userMessage.name = res.info.title;
      commit('UPDATEUSERHEAD', userStore);
      commit('UPDATELOGININFO', userMessage);
    }
  },
  /*获取用户门店列表*/
  async getUserStoreLists ({ commit }) {
    let res = await _axios.post('/pc/Common/GetStoreList', {})
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = lists.length;
      commit('UPDATESTORELISTS', { total, lists });
    }
  },
  /*获取门店绑定的联系人列表*/
  async getStoreLinkLists ({ commit, getters }, storeId) {
    let res = await _axios.post('/pc/Common/GetStoreUserList', { store_id: storeId })
    if (res.code === '00000' || res.code === '99999') return res.info || [];
  },
  /*获取用户职位列表*/
  async getUserPositionLists ({ commit, getters }, data = {}) {
    let t = getters.userInfo.type;
    let url = t === 99 ? '/pc/Admin/PositionList' : '/pc/Common/UnionRecordList'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list || [], total = res.data.count || 0;
      commit('UPDATEPOSITIONLISTS', { total, lists });
    }
  },
  /*销售当前关联列表*/
  async POST_UnionRecordSaleList ({ commit, getters }, {data,successFun}) {
    let t = getters.userInfo.type;
    let url ='/pc/User/UnionRecordSaleList'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      page: 1,
      num: 10,
      needType:'1',
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list || [], total = res.data.count || 0;
      //如果酒店解除了所有的酒店关联、给出提示返回注册时加入酒店页面、清空选择的酒店ID
      if(total<=0){
        _alert('您已解除了所有的酒店关联，请重新加入一个新酒店！',()=>{
          Router.push({ name: 'regBasicClose'});
          let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
          userMessage.storeId = 0;
          commit('UPDATELOGININFO', userMessage);
      },'error');

        
      }
      successFun(total);
      commit('UPDATESALESASSOCIATIONLISTS', { total, lists });
    }
  },
  /*酒店当前关联列表*/
  async POST_UnionRecordEnterpriseList({ commit, getters }, { data,successFun}) {
    let t = getters.userInfo.type;
    let url ='/pc/Common/UnionRecordEnterpriseList'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      successFun();
      let lists = res.data.list || [], total = res.data.count || 0;
      commit('UPDATESALESASSOCIATIONLISTS', { total, lists });
    }
  },
  /*获取关联记录列表*/
  async POST_UnionRecordList ({ commit, getters }, { data,successFun}) {
    let t = getters.userInfo.type;
    let url ='/pc/Common/UnionRecordList'
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      page: 1,
      num: 10,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      successFun();
      let lists = res.data.list || [], total = res.data.count || 0;
      commit('UPDATESALESASSOCIATIONLISTS', { total, lists });
    }
  },
  /*获取用户、管理员权限节点列表*/
  async getUserAccessLists ({ commit, state,getters },{type}) {
    let url = '',data = {};
    switch (getters.userInfo.type) {
      case 99:
        url = '/pc/Admin/GetPositionPowerTree';
        data.is_admin = type;
        break;
      default:
        url = '/pc/Common/GetPositionPowerTree';
        data.position_id = state.userLoginMessage.position;
        break;
    }
    let res = await _axios.post(url,data);
    if (res.code === '00000') commit('UPDATEUSERACCESSLISTS', res.info || {});
  },
  /*获取用户、管理员某一职位的详情*/
  async getPositionDetail ({ commit, state }, id) {
    let res = await _axios.post('/pc/Common/PositionDetail', {
      position_id: id,
    })
    //管理员是否禁用的字段转为字符串
    res.info.is_forbidden = res.info.is_forbidden + '';
    if (res.code === '00000') commit('UPDATEPOSITIONDETAIL', res.info || {});
  },
  /*添加、编辑用户职位*/
  async addEditPosition ({ state,getters }, { type, data,successFun}) {
    let loading = _loading({target: '#addEditPosition'});
    let url = '';
    switch (getters.userInfo.type) {
      case 99:
        url = type === 'add' ? '/pc/Common/AddPosition' : '/pc/Common/EditPosition';
        break;
      default:
        url = type === 'add' ? '/pc/Common/AddPosition' : '/pc/Common/EditPosition';
        break;
    }
    let res = await _axios.post(url, data);
    loading.close();
    if (res.code === '00000') _alert('操作成功',successFun)
  },
  /*删除用户职位*/
  async deletePosition ({ dispatch, state }, data) {
    let loading = _loading({target: '.load-area'});
    let res = await _axios.post('/pc/Common/DelPosition', {
      position_id: data.id,
      type:data.activeTab

    });
    loading.close();
    if (res.code === '00000') dispatch('getUserPositionLists',{type:data.activeTab})
  },
  /*获取用户、管理员(子)账号列表*/
  async getUserStaffLists ({ commit, getters }, data = {}) {
    let url = '',PAGE = Router.currentRoute.query.page || 1;
    switch (getters.userInfo.type) {
      case 99:url =  '/pc/Admin/AdminList'; break;
      default:url = '/pc/Common/UserList'; break;
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      num:NUM,
      page:PAGE,
      ...data
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.data.list || [], total = res.data.count || 0;
      commit('UPDATESTAFFLISTS', { total, lists });
    }
  },
  /*获取指定酒店的用户列表*/
  async PostGetHotelUserList ({ commit, getters }, data = {}) {
    let res = await _axios.post('/pc/Common/GetHotelUserList', {
      ...data
    })
    if (res.code === '00000') {
      return res.data || [];
    }
  },
  /*获取用户添加的账号列表（接口功能类似）*/
  async getUserLists ({ commit, getters },) {
    let res = await _axios.post('/pc/Common/getStoreUserLists', {
      store_id:getters.storeInfo.storeId || Router.currentRoute.query.storeId,
      store_type:6,
    })
    if (res.code === '00000' || res.code === '99999') {
      let lists = res.info || [], total = lists.length;
      commit('UPDATESTAFFLISTS', { total, lists });
    }
  },
  /*查看某一账号管理的门店列表*/
  async getStaffStore ({ commit, getters }, id) {
    let res = await _axios.post('/pc/Common/GetUserStoreList', { user_id: id })
    if (res.code === '00000' || res.code === '99999') {
      return res.info || [];
    }
  },
  /*获取人员架构数组*/
  async getStaffStructure ({ commit, getters }, data) {
    let res = await _axios.post('/pc/Common/GetUserTree', data) 
    if (res.code === '00000'){
      let info=res.info;
      info.name=info.truename+`(${info.name})`
      info.children.forEach(t => {
        t.type = t.truename+`(${t.name})`
      })
      commit('UPDATESTRUCTURE', info|| [])
    }
  },
  /*添加用户(子)账号*/
  async addUserStaff ({ commit, getters }, data) {
    let loading = _loading({ target: '#addStaff' });
    let res = await _axios.post('/pc/Common/AddUser', data);
    loading.close();
    if (res.code === '00000') _alert('添加账号成功！', () => Router.back())
  },
  /*获取用户(子)账号详情*/
  async getStaffDetail ({ commit, state }, id) {
    let loading = _loading({ target: '#addStaff' });
    let res = await _axios.post('/pc/Common/UserDetail', {
      user_id: id,
      is_get_position: '1',
      is_get_store: '1'
    });
    loading.close();
    if (res.code === '00000') commit('UPDATESTAFFDETAIL',res.info);
  },
  /*编辑用户(子)账号*/
  async editUserStaff ({ commit, getters }, data) {
    let loading = _loading({ target: '#addStaff' });
    let res = await _axios.post('/pc/Common/EditUser', data);
    loading.close();
    if (res.code === '00000') _alert('账号编辑成功！', () => Router.back())
  },
  /*注销用户(子)账号*/
  async cancelStaff({ dispatch, getters }, id) {
    let res = await _axios.post('/pc/Common/DelUser',{user_id:id});
    if (res.code === '00000') _alert('账号已注销！', () => dispatch('getUserStaffLists'))
  },
  /*获取登录首页内容*/
  async getUserIndexData({ commit, getters }) {
    let url='';
    //1.供应商销售未认证暂时不调用
    if(getters.userInfo.level==1&&getters.userInfo.type==2) return;
    switch (getters.userInfo.type*1) {
      case 2:url =  '/pc/Travel/LoginShowData'; break;
      case 3:url =  '/pc/Hotel/LoginShowData '; break;
      case 99:url = '/pc/Admin/LoginShowData'; break;
    }
    let res = await _axios.post(url,{
      store_id:getters.storeInfo.storeId
    });
    if (res.code === '00000') {
      commit('UPDATEWAITVERIFY',{
        quotation:res.data.menu_arr.wait_offer_count,
        examine:res.data.menu_arr.wait_pending_count,
        manage:res.data.menu_arr.verify_count,
        register:res.data.menu_arr.reg_verify_count,
        nize:res.data.menu_arr.edit_verify_count,
        payment_count:res.data.treasurer_arr?res.data.treasurer_arr.payment_count:0,
        bankcard_count:res.data.menu_arr.bankcard_count,
        treasurer_count:res.data.menu_arr.treasurer_count,
        withdraw_count:res.data.menu_arr.withdraw_count,
        wait_handle:res.data.menu_arr.wait_handle,
      })
      commit('UPDATEUNREAD',res.data.menu_arr.unread_count);   //未读消息
      commit('UPDATEINDEXDATA',res.data)}
  },
  // 更新用户信息
  async updateInfo ({commit,getters},data) {
    let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage') ) || {};
    // let obj = { ...userMessage, ...data };
    // commit('UPDATELOGININFO', { ...obj });
    // window.localStorage.setItem('userLoginMessage',JSON.stringify(obj));
    if (JSON.stringify(userMessage) != '{}'&&getters.userInfo.type!=99) {
      let resData = await _axios.post('/pc/AuthAndBind/GetLoginInfo', {})
      if (resData.code == '00000') {
        let res = resData.data || resData.info.data;

        if(resData.data.id){
          resData.data.id=resData.data.id*1;
          resData.data.login_time=resData.data.login_time*1;
          resData.data.num=resData.data.num*1;
          resData.data.position_id=resData.data.position_id*1;
          resData.data.type=resData.data.type*1;
        }
        resData.data.type=resData.data.type*1;
        resData.data.uid=resData.data.uid*1;
        let obj = { ...userMessage, ...res };
        commit('UPDATELOGININFO', { ...obj });
        commit('UPDATEUSERHEAD', obj);
        // window.localStorage.setItem('userLoginMessage',JSON.stringify(obj))
      }
    }
  },
  /*其他门店购买记录待处理数据列表*/
  async getBuyWaitData({ commit, getters }) {
    return
    let res = await _axios.post('/pc/Common/getSendNoPayOrderNums',{
      store_id:getters.isGroup ? getters.storeInfo.grostoreId : getters.storeInfo.storeId
    });
    let StoreNopayView = res.info.viewpoint_no_pay
    let StoreNopayPro = res.info.product_no_pay
    let StoreNopays = StoreNopayView + StoreNopayPro
    if (res.code === '00000') commit('UPDATEWAITVERIFY',{StoreNopayView, StoreNopayPro, StoreNopays})
  },
  /*获取用户待处理数据列表*/
  async getWaitHandleData({commit, getters},tyle) {
    let url='';
    //1.供应商销售未认证暂时不调用
    if(getters.userInfo.level==1&&getters.userInfo.type==2) return;
    switch (getters.userInfo.type) {
      case 2:url =  '/pc/Travel/LoginShowData'; break;
      case 3:url =  '/pc/Hotel/LoginShowData '; break;
      case 99:url = '/pc/Admin/LoginShowData'; break;
    };
    let res = await _axios.post(url,{
      store_id:getters.storeInfo.storeId
    });
    if (res.code === '00000') {
      commit('UPDATEWAITVERIFY',{
        quotation:res.data.menu_arr.wait_offer_count,
        examine:res.data.menu_arr.wait_pending_count,
        manage:res.data.menu_arr.verify_count,
        register:res.data.menu_arr.reg_verify_count,
        nize:res.data.menu_arr.edit_verify_count,
        payment_count:res.data.treasurer_arr?res.data.treasurer_arr.payment_count:0,
        bankcard_count:res.data.menu_arr.bankcard_count,
        treasurer_count:res.data.menu_arr.treasurer_count,
        withdraw_count:res.data.menu_arr.withdraw_count,
        wait_handle:res.data.menu_arr.wait_handle,
      })
      commit('UPDATEUNREAD',res.data.menu_arr.unread_count);   //未读消息
      commit('UPDATEINDEXDATA',res.data)
    return
    // let res = await _axios.post('/pc/Common/getWaitingHandleNums',data);
    // if (res.code === '00000') {
    //   let travel = Number(res.info.travel_waitingfor_verify_nums),
    //     hotel = Number(res.info.hotel_waitingfor_verify_nums),
    //     homestay = Number(res.info.homestay_waitingfor_verify_nums),
    //     tourguide = Number(res.info.guide_waitingfor_verify_nums),
    //     scenic = Number(res.info.viewpoint_waitingfor_verify_nums),
    //     brand = Number(res.info.brandhall_waitingfor_verify_nums);
    //   let storeVerify = travel + hotel + homestay + scenic + tourguide + brand;
    //   let order = Number(res.info.order_verify_nums),
    //     room = Number(res.info.room_state_waitingfor_push_nums),
    //     orderHotel = Number(res.info.order_verify_arr.hotel_order_nums),
    //     orderHomestay = Number(res.info.order_verify_arr.homestay_order_nums),
    //     orderScenic = Number(res.info.order_verify_arr.viewpoint_order_nums),
    //     orderYearcard = Number(res.info.order_verify_arr.yearcard_order_nums),
    //     hotelActi = Number(res.info.hotel_onsale_waitingfor_verify_nums),
    //     homestayActi = Number(res.info.homestay_onsale_waitingfor_verify_nums),
    //     ticket = Number(res.info.viewpoint_ticket_verify_nums),
    //     comment = Number(res.info.comment_waitingfor_verify_nums),
    //     vocation = Number(res.info.order_verify_arr.product_order_nums),
    //     withdraw = Number(res.info.edit_withdraw_verify_nums),
    //     orderBrand = Number(res.info.order_verify_arr.brandhall_order_nums)
    //   commit('UPDATEWAITVERIFY',{
    //     travel,
    //     hotel,
    //     homestay,
    //     tourguide,
    //     scenic,
    //     brand,
    //     storeVerify,
    //     hotelActi,
    //     homestayActi,
    //     ticket,
    //     comment,
    //     order,                  //用户待处理订单总数
    //     orderHotel,
    //     orderHomestay,
    //     orderScenic,
    //     orderYearcard,
    //     vocation,
    //     room,
    //     withdraw,
    //     orderBrand
    //   })
    }
  }
}
